//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import Constants from '../../constants';
import AboutMembershipContent from './AboutMembershipContent.react';

import type { ModalProps } from '../../Modal/components/StandardModal.react';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  membershipPlan:MembershipPlanModel,
};

function MsrpPopModal(props:ModalProps&Props){
  return (
    <AboutMembershipContent
      membershipPlan={props.membershipPlan}
    >
      <button className="cta" onClick={props.close}>Got it</button>
    </AboutMembershipContent>
  );
}

export default modal<Props>(MsrpPopModal, {
  name: Constants.MSRP_POP_MODAL,
  className: 'msrp-learn-more-modal',
});
